import React from 'react';
import InputGroup from 'deprecated-shared-ui/templates/input/Group.jsx';
import Select from 'deprecated-shared-ui/templates/input/Select.jsx';
import Label from 'deprecated-shared-ui/templates/input/Label.jsx';
import Messages from '../messages.js';
import MessageBroker from 'deprecated-shared-ui/components/message-broker';

export default function StyleSelection({
                                           styles,
                                           selectedItem,
                                           headline,
                                           layerOrigin,
                                           hasStyleSelectOptions,
                                           channelId,
                                           item,
                                           setSelectedStyle,
                                           setSelectedItem,
                                           setSelectedItemOption,
                                           setIsItemOptionError
                                       }) {

    const changeStyle = (e) => {
        const styleId = e.target.value;
        const currentStyle = styles.find((style) => style.id === styleId);

        const currentSelectedItem =
            currentStyle.items.find((item) => {
                // if style is changed, same color as before must be selected
                const currentColorContainsItemName = selectedItem.name.indexOf(item.name.split(' ')[0]) !== -1;
                return item.name === selectedItem.name || currentColorContainsItemName;
            }) || currentStyle.items[0];

        const currentSelectedItemOption = currentSelectedItem.itemOptions.length === 1 ? currentSelectedItem.itemOptions[0] : null;

        setSelectedStyle(currentStyle);
        setSelectedItem(currentSelectedItem);
        setSelectedItemOption(currentSelectedItemOption);

        const isSingleSize = currentSelectedItem.itemOptions.length === 1;
        setIsItemOptionError(false);

        MessageBroker.publish(Messages.LAYER.CHANGE_ITEM_CHANGE_STYLE, {
            items: currentStyle.items,
            selectedItem: currentSelectedItem,
            isSingleColor: currentStyle.items.length === 1,
        });
    };

    if (!hasStyleSelectOptions) {
        return null;
    }

    const isStyleOption = (style, selectedItem) =>  {
        return style.items.some((item) => {return item.id === selectedItem.id});
    }

    const selectDefaultOption = (styles, selectedItem) => {
        if (!styles) return "";
        const styleIndex = styles.findIndex((style) => isStyleOption(style, selectedItem));
        if (styleIndex === -1) {
            return "";
        } else {
            return styles[styleIndex].id;
        }
    }

    const styleNodes = [];
    styles.forEach((style, index) => {
        styleNodes.push(
            <option key={index} value={style.id}>
                {style.name}
            </option>
        );
    });

    return (
        <div className="change-item__selection">
            <InputGroup className="change-item__selection-input-group">
                <Label className="input-group__label">{headline}</Label>
                <Select name="style" onChange={changeStyle} value={selectDefaultOption(styles, selectedItem)}>
                    {styleNodes}
                </Select>
            </InputGroup>
        </div>
    );
}
